/**
 * The Studio's route helpers. One route since the rebuild replaced the
 * old /studio (TTTL-179) — the helpers stay so entry points keep a single
 * seam (and the ?workspace param keeps its name until the URL scheme is
 * touched, see the loose-ends list).
 */
export function studioPath(): "/studio" {
  return "/studio";
}

/** Opening a workspace/draft in the Studio. */
export function studioWorkspacePath(id: string): string {
  return `/studio?workspace=${encodeURIComponent(id)}`;
}
